import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Role } from '@contrast-security-inc/base-types'
import { SensitiveDataPolicySummary } from '.'

export const sensitiveDataPolicySummariesQuery = gql`
  query SensitiveDataPolicySummaries($organizationID: ID!) {
    sensitiveDataPolicySummaries(organizationID: $organizationID) {
      id
      name
      groupID
      keywords
      enabled
      required
    }
    viewer(organizationID: $organizationID) {
      id
      currentOrganization {
        id
        role
      }
    }
  }
`

export interface ChildProps {
  readonly loading: boolean
  readonly sensitiveDataPolicySummaries: SensitiveDataPolicySummary[]
  readonly isMaskEntireBodyEnabled?: boolean
  readonly refetch: () => Promise<any>
  readonly organizationRole: Role
}

interface Props {
  readonly organizationID: string
  readonly children: (props: ChildProps) => React.ReactNode
}

export function SensitiveDataPolicySummariesLoader({
  organizationID,
  children
}: Props) {
  return (
    <Query<{
      readonly sensitiveDataPolicySummaries: SensitiveDataPolicySummary[]
      readonly viewer: {
        readonly currentOrganization: {
          readonly role: Role
        }
      }
    }>
      query={sensitiveDataPolicySummariesQuery}
      variables={{ organizationID }}
      errorPolicy="all"
    >
      {({ data, error, loading, refetch }) => {
        if (error) {
          throw new Error(error.message)
        }
        const sensitiveDataPolicySummaries: SensitiveDataPolicySummary[] =
          !!data && !!data.sensitiveDataPolicySummaries
            ? data.sensitiveDataPolicySummaries.map(
                ({ id, name, groupID, required, enabled, keywords }) => ({
                  id,
                  name,
                  groupID,
                  required,
                  enabled,
                  keywords
                })
              )
            : []
        const organizationRole: Role =
          !!data && !!data.viewer
            ? data.viewer.currentOrganization.role
            : 'VIEW'
        return children({
          loading,
          sensitiveDataPolicySummaries,
          refetch,
          organizationRole
        })
      }}
    </Query>
  )
}
